<template>
  <Auth>

    <div class="card card-primary">
      <div class="card-header">
        <h4>Login</h4>
      </div>

      <div class="card-body">
        <form method="post" @submit.prevent="login">
          <div class="form-group">
            <label for="email">Username</label>
            <input
              id="username"
              type="username"
              class="form-control"
              name="username"
              tabindex="1"
              required
              autofocus
              v-model="username"
            />
            <div class="invalid-feedback">Please fill in your username</div>
          </div>

          <div class="form-group">
            <div class="d-block">
              <label for="password" class="control-label">Password</label>
              <div class="float-right">
                <a href="auth-forgot-password.html" class="text-small">Forgot Password?</a>
              </div>
            </div>
            <input
              id="password"
              type="password"
              class="form-control"
              name="password"
              tabindex="2"
              required
              v-model="password"
            />
            <div class="invalid-feedback">please fill in your password</div>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input
                type="checkbox"
                name="remember"
                class="custom-control-input"
                tabindex="3"
                id="remember-me"
              />
              <label class="custom-control-label" for="remember-me">Remember Me</label>
            </div>
          </div>

          <div class="form-group">
            <b-button
              type="submit"
              class="btn btn-primary btn-lg btn-block"
              :disabled="loading"
              @click="login"
            >Login</b-button>
          </div>
        </form>
      </div>
    </div>
    <div class="simple-footer">Copyright &copy; JunoMarkets 2020</div>
  </Auth>
</template>

<script>
import Auth from '../layouts/Auth'
import Button from '@/components/utils/Button.vue'
export default {
  components: {
    Auth,
    Button
  },
  data() {
    return {
      username: '',
      password: '',
      loading: false
    }
  },
  methods: {
    login() {
      // TODO : Implements Auth
      this.loading = true
      this.$store.dispatch('user/login', {
        username: this.username,
        password: this.password
      }).then(() => {
        this.$router.push('/exposure')
      }).catch(error => {

        // Failed Login, show error
        this.loading = false
        this.$bvToast.toast(`Login failed, error : ${error.response.data.message}`, {
          title: 'Warning',
          error: true,
          variant: 'danger',
          autoHideDelay: 5000,
        })

      })
    }
  }
}
</script>
